import { render, staticRenderFns } from "./ProductStockCloseList.vue?vue&type=template&id=7b45747d&"
import script from "./ProductStockCloseList.vue?vue&type=script&lang=js&"
export * from "./ProductStockCloseList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports